import { SitesBuilderLibComponent, Comparator } from '@3ddv/ngx-sites-builder-lib';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Toast, ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { SblibService } from '../../services/sblib.service';
import { Indoor } from '../indoor/models/indoor.model';
import { ToolsService } from '../services/tools.service';

@Component({
  selector: 'app-sbeditor-tool-comparator',
  templateUrl: './comparator.component.html',
  styleUrls: ['./comparator.component.scss']
})
export class ComparatorComponent implements OnInit, OnDestroy {
  public enabled: boolean = false;
  public tool: Comparator;
  public indoor: Indoor; 
  private subscriptions: Array<Subscription>;

  constructor(private sblibService: SblibService,
    private toastrService: ToastrService,
    private toolsService:ToolsService) {
    this.subscriptions = [];
  }

  ngOnInit(): void {
    const tools$ = this.toolsService.getAsyncTools$().subscribe(res=>{
      if(res.comparator){
        this.tool = JSON.parse(JSON.stringify(res.comparator));
      } else {
        console.error("comparator tool not found");
        return;
      }

      if(res.indoor){
        this.indoor = JSON.parse(JSON.stringify(res.indoor));
      } else {
        console.error("indoor tool not found");
        return;
      }
    })
    this.subscriptions.push(tools$);
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(o=>o.unsubscribe())
  }

/*  
  deprecated
  public apply(){
    const tools$ = this.toolsService.getAsyncTools$().subscribe(res=>{
      res.comparator = JSON.parse(JSON.stringify(this.tool));
      this.sblibService.apply(res);
      this.toastrService.success("","Success")
    })
    this.subscriptions.push(tools$);
  } */

  public getTool(): { tool: Comparator }{
    return {tool: JSON.parse(JSON.stringify(this.tool))}
  }
}
